export default "__VITE_ASSET__Co1MgnwJ__"